App.directive('loading',($interval) => {
  return {
    restrict:'E',
    templateUrl: '/app/views/partials/loading.html'
  }
})
